import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Room from '@/components/home/Room'
import Pay from '@/components/home/Pay'
import QrCode from '@/components/home/QrCode'
import Details from '@/components/Details'
import Ticket from '@/components/Ticket'
import OrderList from '@/components/OrderList'
import Receipt from '@/components/Receipt'

Vue.use(Router)

export default new Router({
	mode: 'history',
  // mode: 'hash',
	 base: '/waiterOrders/',// 服务员点餐,i=0
	 // base: '/web/',// 扫码点餐,i=1
	routes: [
		{
			path: '/',
			name: 'Login',
			component: Login,
			meta: {
				title: '登陆页面'
			}
		}, {
			path: '/home',
			name: 'Home',
			component: Home,
			meta: {
				title: '桌台页面'
			}
		}, {
			path: '/room',
			name: 'Room',
			component: Room,
			meta: {
				title: '点菜页面'
			}
		}, {
			path: '/pay',
			name: 'Pay',
			component: Pay,
			meta: {
				title: '支付页面'
			}
		}, {
			path: '/QrCode',
			name: 'QrCode',
			component: QrCode,
			meta: {
				title: '支付页面'
			}
		}, {
			path: '/details',
			name: 'Details',
			component: Details,
			meta: {
				title: '详情页面'
			}
		}, {
			path: '/ticket',
			name: 'Ticket',
			component: Ticket,
			meta: {
				title: '取餐小票'
			}
		}, {
			path: '/orderlist',
			name: 'OrderList',
			component: OrderList,
			meta: {
				title: '订单列表'
			}
		}, {
			path: '/receipt',
			name: 'Receipt',
			component: Receipt,
			meta: {
				title: '小票页面'
			}
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js